module.exports = __webpack_public_path__ + "img/operationScanning.25f0f73b.png";